import React from 'react'
import styled from 'styled-components'
import formatTime from '../utils/timeFormatter'

const animationTime = '0.5s'

const NumberStyle = styled.div`
  font-size: 25vh;
  transition: all 1s;
  width: fit-content;
  cursor: pointer;
  color: #332701;
`

const TimeStyle = styled.div`
  position: relative;
`

const GoldenScoreStyle = styled.div`
  font-size: 4vh;
  text-align: center;
  color: rgba(0, 0, 0, 0.45);
  transition: transform ${animationTime};
  text-transform: uppercase;
  position: absolute;
  top: 4px;
  width: 100%;
`

const Timer = ({ toggleTime, time, osaekomi, goldenScore }) => {
  const color = {
    color: `${osaekomi ? 'rgba(0, 0, 0, 0.45)' : '#332701'}`
  }

  const goldenStyle = {
    transform: `${goldenScore ? 'scale(1.0)' : 'scale(0)'}`,
  }

  return (
    <TimeStyle>
      <NumberStyle style={color}>
        <div onClick={toggleTime}>{formatTime(time)}</div>
      </NumberStyle>
      <GoldenScoreStyle style={goldenStyle}>Golden Score</GoldenScoreStyle>
    </TimeStyle>
  )
}

export default Timer



// WEBPACK FOOTER //
// ./src/timer/timer.jsx